import React from 'react';


export const DeleteAtEodDocs = (
  <p>
    When checked, this Trade Plan will be automatically removed at end of day if it has not been
    filled. Equities are cleared at 4:15pm Eastern; futures are cleared at 5pm Eastern. Uncheck to
    carry your Trade Plan over to the next trading day.
  </p>
);
export const DeactivateOnRestartDocs =<p>When a Trade Plan restarts, deactivate the Trade Plan. A button will appear that will
    allow you to activate the Trade Plan when you feel ready</p>;
export const MaxLossDocs = <p>If a repeating Trade Plan exceeds this loss, the Trade Plan will terminate</p>;
export const MaxAttemptsDocs = <p>Once a repeating Trade Plan has run this many times, it will terminate</p>;
export const MaxMinutesDocs = <p>Once a repeating Trade Plan has run for this many minutes, it will terminate. Please note that
    this is
    evaluated at the close of a position for that Trade Plan. Therefore, if this value is set for 15, and a position is
    closed 13 minutes into the Trade Plan&aposs existence, it will still run once more. </p>;
